import { RM08_01 } from "./RM08_01";

export const RM08 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "advancedGauge",
        "colorTheme": 'colorTheme1',
        "title": "CALL RATE",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "title": "Title",
                "value": 'Progress',
                "total": 'Total',
                "endpoint": "RM08",
                "parameters": [
                    { key: "CycleCode", value: "CP1" },
                    { key: "CycleYear", value: "2026" },
                    { key: "RegionCode", value: "RS3" },
                ]
            },
            "context": {
                "point": {
                    "onClick": RM08_01
                }
            }
        }
    }
}